export default __webpack_public_path__ + "static/banner-media-release-nz-travel-survey-8139a9a6f057af1e7c3fa97efad9d139.jpg";